enum ProductCardSelectedStateEnum {
	unselected = 'unselected',
	checkbox = 'checkbox',
	outline = 'outline'
}
export default ProductCardSelectedStateEnum;
